import { useState } from "react";
import { useSelector } from "react-redux";
import { Flex, View } from "@adobe/react-spectrum";
import CaseSidebar from "./CaseSidebar";
// import CaseAi from "../CaseAI/CaseAi";
import { RootState } from "../../../store/storeConfig";
import CaseHistoryWeb from "../CaseHistory/CaseHistoryWeb";
import NoActiveCase from "../CaseInformationContainer/NoActiveCase";
import ChannelHistoryFilter from "../../common/ChannelHistoryFilter/ChannelHistoryFilter";
import { IndividualCase } from "../../../types/case.type";
import ActiveCallContainer from "../../CallTab/CallDialer/ActiveCallContainer";

const CaseHistoryComponent = () => {
  const caseHistory = useSelector((state: RootState) => state.history.cases);
  const [filteredCases, setFilteredCases] = useState(caseHistory || []);
  const [filterAction, setFilterAction] = useState<"all" | "missed">("all");
  const [caseID, setCaseID] = useState(caseHistory[0]?.id);

  const handleAll = () => {
    setFilterAction("all");
    setCaseID(caseHistory[0]?.id);
    setFilteredCases(caseHistory);
  };

  const handleMissed = () => {
    setFilterAction("missed");
    const missedCases = caseHistory.filter(
      (caseItem: IndividualCase) => caseItem?.self?.missed
    );
    setCaseID(missedCases[0]?.id);
    setFilteredCases(missedCases);
  };

  return (
    <View height={"100%"} width={"100%"}>
      {caseHistory?.length > 0 && (
        <ChannelHistoryFilter
          activeFilter={filterAction}
          onAll={handleAll}
          onMissed={handleMissed}
        />
      )}
      <Flex width={"100%"} height={"90.5%"}>
        {filteredCases?.length > 0 ? (
          <>
            <View backgroundColor="static-white" width={"22%"}>
              <CaseSidebar
                setCaseID={setCaseID}
                filteredCases={filteredCases}
              />
            </View>
            <View backgroundColor="static-white" width={"100%"}>
              <CaseHistoryWeb caseID={caseID} />
            </View>
          </>
        ) : filterAction === "all" ? (
          <NoActiveCase />
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            width="90%"
            height="90%"
          >
            <ActiveCallContainer
              type="case"
              title={"No Missed Case history"}
              description={"Start a new case or Wait for a case"}
            />
          </Flex>
        )}
      </Flex>
    </View>
  );
};

export default CaseHistoryComponent;
